import { Grid, Typography } from '@mui/material';
import { LineLink } from 'main/components/_common/LineLink';

export const ContactNotes = () => {
    return (
        <Grid data-testid="contact-notes" container direction="column" px={1}>
            <Grid item data-testid="contact-page-note-1">
                <Typography variant="body2">
                    返信先アドレスをお間違えの無いようにお願いします。後ほど担当者より返信させて頂きます。
                </Typography>
            </Grid>
            <Grid data-testid="contact-page-note-2" item container direction="row" alignItems="center" gap={1}>
                <Typography variant="body2">
                    LINEでのお問い合わせを希望の方はこちら
                </Typography>
                <LineLink size={36} />
            </Grid>
        </Grid>
    )
}
